export default "__VITE_ASSET__0248bb2e__"